import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "p-h-give-point-page-icon"
}
const _hoisted_2 = { class: "p-h-give-point-page-icon__inner" }
const _hoisted_3 = { class: "p-h-give-point-page-icon__to" }
const _hoisted_4 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_IconUserImage = _resolveComponent("IconUserImage")!

  return (_ctx.to && _ctx.from)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createVNode(_component_IconUserImage, { size: _ctx.recipientIconSize }, {
              default: _withCtx(() => [
                _createElementVNode("img", {
                  src: _ctx.to,
                  alt: ""
                }, null, 8, _hoisted_4)
              ]),
              _: 1
            }, 8, ["size"])
          ])
        ])
      ]))
    : _createCommentVNode("", true)
}